<template>
  <div class="crypto-section">
    <div class="input-container">
      <input
        type="number"
        :value="takeAmount"
        @input="
          $emit('update:take-amount', parseFloat($event.target.value) || 0);
          changeGiveAmount(parseFloat($event.target.value) || 0);
        "
      />
      <div class="desc">{{ takeCurrency.crypto_currency }}</div>
    </div>

    <div class="fee-list" v-if="calculatedFees && fiatToCrypto">
      <div class="list">
        <div class="desc title">{{ $t("Fees:") }}</div>
        <div class="item item-fee">
          <div class="text">
            <div class="key">{{ $t("Our fee:") }}</div>
            <div class="value">
              {{
                calculatedFees.commissionFee
                  ? calculatedFees.commissionFee
                  : "Processing..."
              }}
            </div>
          </div>
        </div>
        <div class="item item-total">
          <div class="text">
            <div class="key">{{ $t("Total:") }}</div>
            <div class="value">
              {{
                calculatedFees.total ? calculatedFees.total : "Processing..."
              }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!fiatToCrypto" class="radio-list payment-method-list">
      <div class="desc">{{ $t(`Payment method:`) }}</div>
      <div class="list">
        <div class="item">
          <label>
            <input
              type="radio"
              :checked="paymentMethod === 'crypto'"
              @change="$emit('update:payment-method', 'crypto')"
              name="paymentMethod"
              value="crypto"
            />
            <div class="text">
              <div class="desc">{{ $t(`Crypto`) }}</div>
            </div>
          </label>
        </div>
      </div>
    </div>

    <div class="radio-list cryptocurrency-list">
      <div class="desc title">{{ $t(`Assets:`) }}</div>
      <div class="list" v-if="filteredRates && filteredRates.length">
        <div class="item" v-for="item in filteredRates" :key="item.id">
          <label>
            <input
              type="radio"
              :checked="takeCurrency.crypto_currency === item.crypto_currency"
              @change="$emit('update:take-currency', item)"
              :value="item.crypto_currency"
            />
            <div class="text">
              <div class="desc">
                {{ item.crypto_currency }} {{ item.price }} : 1
              </div>
            </div>
          </label>
        </div>
      </div>

      <div class="list" v-else>
        <div class="item">
          <label>
            <input type="radio" checked />
            <div class="desc">{{ $t(`No assets available`) }}</div>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CryptoSection",
  props: {
    giveCurrency: {
      type: Object,
    },
    rates: {
      type: Array,
    },
    filteredRates: {
      type: Array,
    },
    takeCurrency: {
      type: Object,
    },
    takeAmount: {
      type: Number,
    },
    changeGiveAmount: {
      type: Function,
    },
    toggleFiatToCrypto: {
      type: Function,
    },
    paymentMethod: {
      type: String,
    },
    fiatToCrypto: {
      type: Boolean,
    },
    calculatedFees: {
      type: Object,
    },
  },
  data: function () {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.crypto-section .fee-list {
  margin-top: 16px;

  .key {
    font-size: 14px;
    font-weight: 400;
    line-height: 19px;
    text-align: left;
    color: #141427;
  }

  .value {
    font-size: 14px;
    font-weight: 400;
    line-height: 19px;
    color: #282e38;
  }

  .text {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }

  .item-fee {
    margin-bottom: 32px;
  }

  .desc.title {
    font-size: 14px;
    line-height: 19px;
    color: #282e38;
    margin-bottom: 16px;
    font-weight: 700;
  }
}
</style>
